// MIGRACIÓN A WINDOWSTORE: Importar la nueva función
import { openWhatsappWindow } from "./openWhatsappWindow";
import { OpenWhatsappPanelParams } from "../typings";

// IMPLEMENTACIÓN ANTERIOR CON FLOATINGPANEL (COMENTADA)
/*
import { WhatsappCompose } from "../WhatsappCompose";
import ClientService from "../../../services/ClientService";
import { PanelWhatsAppTitle } from "../PanelWhatsAppTitle";
import { OpenWhatsappPanelParams, WhatsappPanelMode } from "../typings";
import FloatingPanelService from "../../../pages/shared/FloatingPanel";
import CompanyService from "../../../services/CompanyService";
*/

export async function openWhatsappPanel(
  params: OpenWhatsappPanelParams
): Promise<void> {
  // NUEVA IMPLEMENTACIÓN: Usar windowStore para ventanas persistentes
  await openWhatsappWindow(params);
}

// IMPLEMENTACIÓN ANTERIOR CON FLOATINGPANEL (COMENTADA PARA REFERENCIA)
/*
export async function openWhatsappPanel({
    client: clientArg,
    personId,
    onSubmit,
    afterFinally,
    historyMessageId,
}: OpenWhatsappPanelParams): Promise<void> {
    let client = clientArg;

    try {
        if (!client) {
            const id = personId?.toString();
            if (!id) return;
            const res = await ClientService.get({ id });
            if (res instanceof Error) return;
            client = res.item;
            if (!client) return;
        }

        let headerApi: { setHideActivityTypeSelector: (hidden: boolean) => void } | null = null;
        let setActivityTypeFromTitle: ((activityTypeId: number) => void) | null = null;
        let clearActivityTypeFromTitle: (() => void) | null = null;

        const mode: WhatsappPanelMode = historyMessageId
            ? { kind: "history", messageId: historyMessageId.toString() }
            : { kind: "active", personId: client.PersonId.toString() };

        const WIDTH = 450;
        const HEIGHT = 650;

        const whatsappPhone = (
            CompanyService.getCompanyAuth()?.DefaultWhatsappField === -1
                ? client.Phone
                : client.additionals.find((x) => x.id === CompanyService.getCompanyAuth()!.DefaultWhatsappField)?.value
        )

        // Cerrar el modal anterior si existe
        FloatingPanelService.hidePanel();

        FloatingPanelService.showPanel({
            title: (
                <PanelWhatsAppTitle
                    name={client?.Name}
                    phone={whatsappPhone}
                    onSelectTemplate={(activityTypeId) => {
                        setActivityTypeFromTitle?.(activityTypeId);
                    }}
                    registerExternalController={(api) => {
                        headerApi = api;
                    }}
                />
            ),
            children: (
                <WhatsappCompose
                    person={client!}
                    mode={mode}
                    onSubmit={onSubmit}
                    onMainMessageState={(hasMain) => headerApi?.setHideActivityTypeSelector(hasMain)}
                    onRegisterActivityTypeSetter={(setFn, clearFn) => {
                        setActivityTypeFromTitle = setFn;
                        clearActivityTypeFromTitle = clearFn || clearActivityTypeFromTitle;
                    }}
                    whatsappPhone={whatsappPhone}
                />
            ),
            width: WIDTH,
            height: HEIGHT,
        });
    } finally {
        afterFinally?.();
    }
}
*/
